import { TitleSection } from "../title-section";

export const MarcosBiografy = () => {
  return (
    <section
      id="indications"
      className="py-10 px-4 lg:px-0 flex justify-center"
    >
      <div className="w-full lg:max-w-screen-md xl:max-w-screen-xl 2xl:max-w-screen-2xl">
        <TitleSection blueToRed first_title="Biografia" />
        <div className="mt-6 flex flex-col md:flex-row items-center md:items-start text-center md:text-left gap-6">
          <div className="flex-shrink-0">
            <img
              src={require("../../assets/marcos.jpg")}
              alt="Marcos Manoel Silva Severiano"
              className="rounded-xl w-40 h-40 object-cover mx-auto md:mx-0"
            />
          </div>
          <div className="text-gray-700 text-lg leading-relaxed">
            <p>
              <strong>Marcos Manoel Silva Severiano</strong> é licenciado em
              História (URCA), bacharel em Psicologia (UniLeão), com
              especialização em Gestão Escolar (Faculdade Descomplica) e
              Docência do Ensino Superior (UniLeão), mestrando em História pelo
              ProfHistória (URCA). Desenvolve atividades nas áreas de educação,
              história e psicologia, atuando com gestão escolar, direção
              pedagógica e coordenação pedagógica, além de professor do Ensino
              Médio da rede estadual e privada no Estado do Ceará.
            </p>
            <p className="mt-4">
              Também é criador de conteúdo digital através do Canal Paradigmata
              no{" "}
              <a
                href="https://www.youtube.com/@paradigmata"
                className="text-blue-600 hover:underline"
              >
                YouTube
              </a>{" "}
              e{" "}
              <a
                href="https://open.spotify.com/show/Paradigmata"
                className="text-blue-600 hover:underline"
              >
                Spotify
              </a>
              .
            </p>
            <div className="mt-4">
              <p>
                Redes sociais:{" "}
                <span className="font-semibold">@marcosrua47</span>
              </p>
              <p>
                ID Lattes:{" "}
                <a
                  href="http://lattes.cnpq.br/5429477567940296"
                  className="text-blue-600 hover:underline"
                >
                  Acessar
                </a>
              </p>
              <p>
                ID ORCID:{" "}
                <a
                  href="https://orcid.org/0009-0009-0876-624X"
                  className="text-blue-600 hover:underline"
                >
                  Acessar
                </a>
              </p>
              <p>
                Email:{" "}
                <a
                  href="mailto:marcosmanoelsilvaseveriano@gmail.com"
                  className="text-blue-600 hover:underline break-all"
                >
                  marcosmanoelsilvaseveriano@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
